import { TokenModel } from '@/config/tokenModel.ts'
import { restockStore } from '@/@types/restock'
import { getMessage } from "@/api/Kilimall/home";
let interval:number = -1
const state = {
    token: null,
    userInfo:{},
    store_info:{},
    messageCount: 0,
    siteCode: null
}
const mutations = {
    setSiteCode (state: any, site_code: string) {
        state.siteCode = site_code
    },
    setToken (state: any, user_token: string) {
        localStorage.setItem(TokenModel.token_name, user_token)
        state.token = user_token
    },
    clearToken (state: any) {
        localStorage.removeItem(TokenModel.token_name)
        state.token = null
        localStorage.removeItem(TokenModel.user_info)
        state.userInfo = {}    
        localStorage.removeItem(TokenModel.store_info)
        state.store_info = {}  
        localStorage.removeItem(restockStore.restock_shipping)
        localStorage.removeItem(restockStore.restock_warehouse)
        localStorage.removeItem(restockStore.restock_maps)
        window.location.href = window.location.origin + '/login'
    },
    setUserInfo(state: any, user_info: any){
        localStorage.setItem(TokenModel.user_info, JSON.stringify(user_info))
        state.userInfo = user_info
    },
    setStoreInfo(state: any, store_info: any){
        localStorage.setItem(TokenModel.store_info, JSON.stringify(store_info))
        state.store_info = store_info
    },
    setMessageCount(state: any, total: number) {
      state.messageCount = total
    }

}
const actions = {
    setSiteCode(context: any, site_code: string) {
        context.commit('setSiteCode', site_code)
    },
    setToken(context: any, user_token: string) {
        context.commit('setToken', user_token)
    },
    setUserInfo(context: any, user_info: string) {
        context.commit('setUserInfo', user_info)
    },
    setStoreInfo(context: any, store_info: string) {
        context.commit('setStoreInfo', store_info)
    },
    clearToken(context: any) {
        context.commit('clearToken')
    },
    async setMessageCount(context: any) {
      console.log("🚀 ~ getMessage ~ res:", 222)
      // 定时器已经存在
      if(interval !== -1) {
        return
      }

      const initTotal = () => getMessage().then((res: any) => {
        if (res.code === 200) {
          context.commit('setMessageCount', Number(res.data.total))
        }
      })

      await initTotal()
      
      interval = setInterval(initTotal, 180000)
    },
}
export default {
    state,
    mutations,
    actions
}